<template lang="pug">
app-page(:singleView="true")
  template(slot="content")
    v-card(height="100%")
      v-dialog(v-model="dialog" persistent width="300")
        v-card(color="primary" dark)
          v-card-text Exporting - Please wait
            div(class="text-xs-center")
                v-progress-circular(indeterminate color="purple" :size="50" :width="5" )
      v-card-title
        v-layout(align-center row)
          v-breadcrumbs(:items="breadCrumbItems")
          template(v-if="isAllowedTo(1)")
            v-spacer
            v-btn(flat outline @click="exportPage()" id="export-btn")
              v-icon open_in_browser
      v-container(
        fluid
        style="min-height: 0; padding-top:0px;"
        grid-list-xl
      )
        v-layout(row)
          v-flex(xs12).column
            c-e-module-renderer(
              ref="cem"
              :cemoduleId="parseInt($route.params.moduleId, 10)"
              :apply-context="true"
              :md-content="content.page"
              :tree-content="content"
              :isEndPage="checkIsEnd()"
              @previous="previousPage"
              @next="nextPage"
            )
</template>

<script>
import striptags from 'striptags';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import Base from 'views/Base';
import CEModuleRenderer from 'components/content/CEModuleRenderer';
import { content } from 'api';
import mergeFieldToLowerCase from '@/lib/util';
import * as types from 'store/mutationTypes';
// import html2pdf from 'html2pdf.js';

const nunjucks = require('nunjucks');

export default {
    name: 'Page',

    extends: Base,

    components: {
        CEModuleRenderer
    },

    data() {
        return {
            content: {
                path: '',
                page: ''
            },
            dialog: false,
            breadCrumbItems: [],
        };
    },

    watch: {
        // Reload the page contents on each route change. Set to immediate
        // mode so that the watch handler runs the first time.
        $route: {
            immediate: true,
            async handler(to, from) {
                await this.getPage(
                    parseInt(to.params.moduleId, 10),
                    to.params.pagePath
                );

                this.calculateBreadCrumbItems(
                    parseInt(to.params.moduleId, 10),
                    to.params.pagePath
                );
            }
        },

        navigation() {
            const id = parseInt(this.$route.params.moduleId, 10);
            const path = this.$route.params.pagePath;
            if (!this.navigation[id]) {
                this.$router.push('/');
            }
            if (!this.navigation[id][path]) {
                const result = this.navigation[id];
                const { lineage } = this.navigation[id][Object.keys(result)[0]];
                const firstPath = lineage[0].path;
                this.$router.push({
                    name: 'Page',
                    params: { moduleId: id, pagePath: firstPath }
                });
            }
            this.calculateBreadCrumbItems(
                parseInt(this.$route.params.moduleId, 10),
                this.$route.params.pagePath
            );
        }
    },

    computed: {
        ...mapState({
            initialised: state => state.app.initialised,
            navigation: state => state.navigation.navigation,
            pageNameMap: state => state.navigation.pageNameMap
        }),

        ...mapGetters({
            contextItemValues: 'clientContext/values',
            isAllowedTo: 'session/isAllowedTo',
            isAuthenticated: 'session/isAuthenticated',
            activatedCEModules: 'activatedCEModules/items'
        })
    },

    methods: {
        async getPage(moduleId, pagePath) {
            if (this.loading) return;
            this.setLoading(true);

            function setTwoColumnsWidth(content) {
                let newContent = content;
                const theads = content.replace(/\r\n/g, '').replace(/\r/g, '').replace(/\n/g, '').match(/<thead>(.*?)<\/thead>/g);
                if (theads) {
                    const replaceArray = [];
                    const thTag = '<th>';
                    const newThTag = '<th style = "width : 30%">';
                    theads.forEach((x) => {
                        const thArray = x.split(thTag);
                        if (thArray.length === 3) {
                            const oldString = thTag + thArray[1];
                            const newString = newThTag + thArray[1];
                            replaceArray.push({ oldString, newString });
                        }
                    });
                    if (replaceArray.length > 0) {
                        replaceArray.forEach((x) => {
                            newContent = newContent.replace(x.oldString, x.newString);
                        });
                    }
                }
                return newContent;
            }

            try {
                // this.setViewTitle(this.currentPage.name);
                const response = await content.getPage(
                    moduleId,
                    'master',
                    encodeURIComponent(pagePath),
                    // TODO We can retrieve all pages by setting this to true
                    false
                );

                this.content = {
                    path: response.data.path,
                    page: setTwoColumnsWidth(response.data.page),
                    children: response.data.children
                };

                this.$store.commit(types.NAVIGATION_SET_CURRENT_PAGE, {
                    moduleId,
                    path: response.data.path,
                    setActiveTOC: true
                });
                this.$emit('updateNav', {
                    moduleId,
                    path: response.data.path
                });
            } catch (err) {
                this.showErrorAlert(err.message);
            } finally {
                this.setLoading(false);
            }
        },

        previousPage() {
            const moduleId = this.$route.params.moduleId;
            const previousPagePath =
                this.navigation[moduleId][this.content.path].previous;

            if (previousPagePath === '') return;
            this.$router.push({
                name: 'Page',
                params: { moduleId, pagePath: previousPagePath }
            });
        },

        nextPage() {
            const moduleId = this.$route.params.moduleId;
            const nextPagePath =
                this.navigation[moduleId][this.content.path].next;

            if (nextPagePath === '') return;
            this.$router.push({
                name: 'Page',
                params: { moduleId, pagePath: nextPagePath }
            });
        },

        checkIsEnd() {
            const moduleId = this.$route.params.moduleId;
            const navigationItem = this.navigation[moduleId];
            if (navigationItem) {
                const navigation = navigationItem[this.content.path];
                if (navigation) {
                    const nextPagePath = navigation.next;
                    if (nextPagePath === '') {
                        return true;
                    }
                }
            }
            return false;
        },

        exportPage() {
            const el = this.$refs.cem.$el;
            const titleArray = el.getElementsByClassName('page-title');
            const filename = titleArray && titleArray[0] ?
                `${titleArray[0].innerHTML.trim()}` : 'Print View';
            const winPrint = window.open('', filename, 'toolbar=0,titlebar=1,scrollbars=1,status=0');
            const dateTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

            // TODO Move this to static template file
            winPrint.document.write(
                `
                <html>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                <link href='https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons' rel="stylesheet">
                <!--link href="https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css" rel="stylesheet"-->
                <style>
                .readable-content {
                /* HTML5 display-role reset for older browsers */
                font-family: Roboto, "Helvetica Neue", sans-serif;
                font-size: 1.3em;
                color: #555;
                /*max-width: 34em;
                margin: auto;*/
                margin: 60;
                padding: 1em;
                -moz-osx-font-smoothing: grayscale;
                -webkit-font-smoothing: antialiased !important;
                -moz-font-smoothing: antialiased !important;
                text-rendering: optimizelegibility !important;
                line-height: 1.58;
                letter-spacing: .003em; }
                .readable-content html, .readable-content body, .readable-content div, .readable-content span, .readable-content applet, .readable-content object, .readable-content iframe,
                .readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6, .readable-content p, .readable-content blockquote, .readable-content pre,
                .readable-content a, .readable-content abbr, .readable-content acronym, .readable-content address, .readable-content big, .readable-content cite, .readable-content code,
                .readable-content del, .readable-content dfn, .readable-content em, .readable-content img, .readable-content ins, .readable-content kbd, .readable-content q, .readable-content s, .readable-content samp,
                .readable-content small, .readable-content strike, .readable-content strong, .readable-content sub, .readable-content sup, .readable-content tt, .readable-content var,
                .readable-content b, .readable-content u, .readable-content i, .readable-content center,
                .readable-content dl, .readable-content dt, .readable-content dd, .readable-content ol, .readable-content ul, .readable-content li,
                .readable-content fieldset, .readable-content form, .readable-content label, .readable-content legend,
                .readable-content table, .readable-content caption, .readable-content tbody, .readable-content tfoot, .readable-content thead, .readable-content tr, .readable-content th, .readable-content td,
                .readable-content article, .readable-content aside, .readable-content canvas, .readable-content details, .readable-content embed,
                .readable-content figure, .readable-content figcaption, .readable-content footer, .readable-content header, .readable-content hgroup,
                .readable-content main, .readable-content menu, .readable-content nav, .readable-content output, .readable-content ruby, .readable-content section, .readable-content summary,
                .readable-content time, .readable-content mark, .readable-content audio, .readable-content video {
                margin: 0;
                padding: 0;
                border: 0;
                font-size: 100%;
                font: inherit;
                vertical-align: baseline; }
                .readable-content article, .readable-content aside, .readable-content details, .readable-content figcaption, .readable-content figure,
                .readable-content footer, .readable-content header, .readable-content hgroup, .readable-content main, .readable-content menu, .readable-content nav, .readable-content section {
                display: block; }
                .readable-content body {
                line-height: 1; }
                .readable-content ol, .readable-content ul {
                list-style: none; }
                .readable-content blockquote, .readable-content q {
                quotes: none; }
                .readable-content blockquote:before, .readable-content blockquote:after, .readable-content q:before, .readable-content q:after {
                  content: '';
                  content: none; }
                .readable-content table {
                border-collapse: collapse;
                border-spacing: 0; }
                .readable-content .page-title, .readable-content h1, .readable-content h2, .readable-content h3, .readable-content h4, .readable-content h5, .readable-content h6 {
                margin-top: 1.3em;
                margin-bottom: 1.3em;
                margin-right: 0;
                margin-left: 0;
                font-family: Roboto, "Helvetica Neue", sans-serif;
                font-weight: 700;
                color: #222; }
                .readable-content h1 {
                font-size: 2.6em; }
                .readable-content h2 {
                font-size: 1.95em; }
                .readable-content h3 {
                font-size: 1.625em; }
                .readable-content h4 {
                font-size: 1.3em; }
                .readable-content h5 {
                font-size: 1.3em; }
                .readable-content h6 {
                font-size: 1.3em; }
                .readable-content header {
                padding-bottom: 1.3em;
                margin-bottom: 1em; }
                .readable-content header h1, .readable-content header h2 {
                  margin: .5em 0; }
                .readable-content header.center {
                  text-align: center; }
                .readable-content header h2 {
                  color: #777; }
                .readable-content a {
                color: #555;
                text-decoration: underline; }
                .readable-content a:hover {
                  color: #222; }
                .readable-content mark {
                color: #555;
                background-color: rgba(82, 232, 165, 0.3); }
                .readable-content strong, .readable-content b {
                font-weight: 700; }
                .readable-content em, .readable-content i, .readable-content cite, .readable-content blockquote, .readable-content q {
                font-style: italic; }
                .readable-content small {
                font-size: 0.78em; }
                .readable-content big {
                font-size: 1.56em; }
                .readable-content abbr[title], .readable-content acronym[title] {
                text-decoration: underline dotted; }
                .readable-content sup {
                vertical-align: super;
                font-size: 0.78em; }
                .readable-content sub {
                vertical-align: sub;
                font-size: 0.78em; }
                .readable-content u {
                text-decoration: underline; }
                .readable-content img {
                max-width: 100%;
                display: block;
                margin: 1.3em auto; }
                .readable-content img.big {
                  margin-top: 1.3em;
                  margin-bottom: 1.3em;
                  margin-right: 0;
                  margin-left: 0;
                  width: 120%;
                  margin-left: -10%; }
                .readable-content p {
                margin-top: 1.3em;
                margin-bottom: 1.3em;
                margin-right: 0;
                margin-left: 0;
                line-height: 1.58;
                color: #555;
                font-family: Roboto, "Helvetica Neue", sans-serif; }
                .readable-content blockquote {
                margin-top: 1.3em;
                margin-bottom: 1.3em;
                margin-right: 0;
                margin-left: 0;
                margin-left: 1.3em;
                border-left: 0.325em solid #dddddd;
                padding-left: 1.3em; }
                .readable-content code {
                background-color: #dddddd;
                opacity: .9;
                padding: 0.1625em 0.325em;
                border-radius: 3px; }
                .readable-content ul {
                list-style: disc outside none; }
                .readable-content ol {
                list-style: decimal outside none; }
                .readable-content li {
                margin-top: 0.65em;
                margin-bottom: 0.65em;
                margin-right: 0;
                margin-left: 0;
                margin-left: 1.3em; }
                .readable-content dl {
                margin-top: 1.3em;
                margin-bottom: 1.3em;
                margin-right: 0;
                margin-left: 0; }
                .readable-content dl dt {
                  font-weight: 700; }
                .readable-content dl dd {
                  margin-left: 1.3em; }
                .readable-content dl dt + dd {
                  margin-bottom: 1.3em; }
                .readable-content table {
                text-align: left;
                border-collapse: collapse;
                vertical-align: middle;
                width: 100%; }
                .readable-content td, .readable-content th {
                  vertical-align: middle;
                  border-width: 1px;
                  border-style: solid;
                  border-color: #777;
                  padding: 8px; }
                .readable-content th {
                /*text-align: center;
                font-weight: 700;
              color: white;*/ }
                .readable-content thead th {
                background-color: #f2f2f2; }
                .readable-content tbody tr:nth-child(even) {
                background-color: #f2f2f2; }
                .readable-content.no-margin {
                max-width: none;
                margin: 0; }

                .readable-content .page-title {
                    font-size: 2.8em;
                }

                .readable-content .display-name {
                    font-size: 22px;
                    font-weight: 400;
                    color: #555757;
                    line-height: 32px;
                    letter-spacing: normal;
                }

                /*
                .readable-content .placeholder {
                    background: ${this.$vuetify.theme.secondary};
                }
                */

                .readable-content table {
                    border-collapse: collapse;
                    vertical-align: middle;
                    width: 100%;
                }

                .readable-content img {
                    width: 100%;
                    height: auto;
                }

                body {
                    margin: 20;
                    padding 20;
                    font-family: Roboto, "Helvetica Neue", sans-serif;
                }

                .divHeader {
                    position: fixed;
                    top: 0;
                }
                .divFooter {
                    position: fixed;
                    bottom: 0;
                }

                button {
                  display: none;
                }

                .readable-content h1::before,
                .readable-content h2::before,
                .readable-content h3::before,
                .readable-content h4::before,
                .readable-content h5::before,
                .readable-content h6::before,
                .readable-content .page-title::before,
                .divFooter::after,
                .divHeader::before
                {
                    content: "This document was current as at ${dateTime}. Updates to content may have been made since this date. Refer to your policy site for the latest version.\\A";
                    white-space: pre;
                    font-style: italic;
                    font-size:8px;
                    color:LightGray;
                }
                .underline {
                  text-decoration: underline;
                }
                </style>
                <title>${filename}</title>
                </head>
                <body class="readable-content">
                <div class="divHeader"></div>
                <div class="divFooter"></div>
                ${el.innerHTML}
                </body>
                </html>
            `
            );
            winPrint.document.close();
        },

        calculateBreadCrumbItems(cemoduleId, pagePath) {
            if (!this.navigation[cemoduleId]) return;

            const lineage = this.navigation[cemoduleId][pagePath].lineage;

            this.breadCrumbItems = lineage.map((item, index) => {
                // Remove any HTML tags from the context key value
                // No need to render using formatting
                // TODO: Speed this up by just using regex instead of nunjucks
                const text = nunjucks.renderString(
                    mergeFieldToLowerCase(item.name),
                    this.contextItemValues
                );
                return {
                    text: striptags(text),
                    key: item.name,
                    to: `/module/${cemoduleId}/page/${item.path}`,
                    disabled: index === lineage.length - 1
                };
            });

            // add Module Name to return to the main Quicklinks page
            if (this.activatedCEModules && this.activatedCEModules.length > 0) {
                const selectedModule = this.activatedCEModules.find(selectedModule =>
                    selectedModule.id === cemoduleId);
                if (selectedModule) {
                    this.breadCrumbItems.unshift({
                        text: selectedModule.displayName,
                        key: selectedModule.displayName,
                        to: '/',
                        disabled: false
                    });
                }
            }
            // add Home to return to the main Quicklinks page
            this.breadCrumbItems.unshift({
                text: 'Home',
                key: 'Home',
                to: '/',
                disabled: false
            });
        }
    }
};
</script>

<style>
.vertical-divider{
  clear: both;
  position: relative;
}

.vertical-divider:after {
  clear: both;
  content: " ";
  display: block;
  height: 0;
  visibility: hidden;
}

.vertical-divider .column:not(:first-child):after {
  background: #DDDDDD;
  bottom: 110px;
  content: " ";
  margin-left: -10px;
  position: absolute;
  top: 110px;
  width: 1px;
}

.vertical-divider .columns:not(:first-child):after {
  background: #DDDDDD;
  bottom: 110px;
  content: " ";
  margin-left: -10px;
  position: absolute;
  top: 110px;
  width: 1px;
}

#export-btn {
  margin-right: 24px;
  color: var(--v-secondary-base) !important;
  border-radius: 22px;
  height: 44px;
  width: 44px;
  min-width: 24px;
}

#export-btn .v-icon {
  font-size: 24px;
}

.container {
  max-width: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Page.vue